/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { getTranslation } from 'common/react/utils/translations';
import { SvgIcon } from 'common/react/components/SvgIcon';

const LAST_UPDATED_FORMAT = 'h:mmA dddd, MMMM D, YYYY';

export const LastUpdated = ({ cssClass, lastUpdated, selectedRegion }) => (
    <div className={`${cssClass}`}>
        <SvgIcon icon="info" className="icon" />
        <p>
            {getTranslation('label.lastUpdated.title')}
            <span>
                {lastUpdated
                    .tz(selectedRegion.timezone)
                    .format(LAST_UPDATED_FORMAT)}
            </span>
        </p>
    </div>
);

LastUpdated.propTypes = {
    lastUpdated: PropTypes.object.isRequired,
    selectedRegion: PropTypes.object.isRequired,
    cssClass: PropTypes.string
};
